import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  data: [],
  agenciesLoading: false,
  agenciesLoaded: false,
};

const agenciesSlice = createSlice({
  name: "agencies",
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    setAgencies(state, { payload }) {
      state.data = payload || [];
    },
    setAgenciesLoading(state, { payload }) {
      state.agenciesLoading = payload;
    },
    setAgenciesLoaded(state, { payload }) {
      state.agenciesLoaded = payload;
    },
  },
});

export const { reset, setAgencies, setAgenciesLoading, setAgenciesLoaded } =
  agenciesSlice.actions;

export default agenciesSlice;
